import React from 'react';
import { summaryPoints } from '../lib/data';

const DOT = {
  green: 'bg-emerald-500',
  amber: 'bg-amber-500',
  rose: 'bg-rose-500',
  neutral: 'bg-slate-400',
};

// The eligibility summary as scannable bullet lines (plan, network, deductible,
// coinsurance, copay, flags) instead of one dense sentence. Built from the
// structured check fields via summaryPoints(); falls back to summaryText.
export default function SummaryPoints({ check, provider, payer, className = '', size = 'md' }) {
  const points = summaryPoints(check, provider, payer);
  if (!points.length) {
    return <p className={`text-slate-800 leading-relaxed ${className}`}>{check?.summaryText}</p>;
  }
  const text = size === 'sm' ? 'text-sm' : 'text-[15px]';
  return (
    <ul className={`space-y-1.5 ${className}`}>
      {points.map((p, idx) => (
        <li key={idx} className={`flex items-start gap-2 ${text} leading-relaxed`}>
          <span className={`mt-[7px] h-1.5 w-1.5 rounded-full shrink-0 ${DOT[p.tone] || DOT.neutral}`} />
          <span className="text-slate-800"><span className="font-medium text-slate-900">{p.label}:</span> {p.value}</span>
        </li>
      ))}
    </ul>
  );
}
